// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"_m16j74","loaderWrapper":"_m16j74","font-upgrade":"_1pc94j9","fontUpgrade":"_1pc94j9"};